import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0720763c"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = { class: "sm:flex sm:flex-wrap" }
const _hoisted_3 = { class: "font column md:pr-x2" }
const _hoisted_4 = { class: "font-dt" }
const _hoisted_5 = {
  key: 0,
  class: "inline-block ml-5 mr-3"
}
const _hoisted_6 = {
  key: 0,
  class: "font column"
}
const _hoisted_7 = { class: "font-dt" }
const _hoisted_8 = {
  key: 1,
  class: "font column"
}
const _hoisted_9 = { class: "font-dt" }
const _hoisted_10 = {
  key: 2,
  class: "font column"
}
const _hoisted_11 = { class: "font-dt" }
const _hoisted_12 = {
  key: 3,
  class: "font column"
}
const _hoisted_13 = { class: "font-dt" }
const _hoisted_14 = {
  key: 4,
  class: "font column"
}
const _hoisted_15 = { class: "font-dt" }
const _hoisted_16 = {
  key: 5,
  class: "font column"
}
const _hoisted_17 = { class: "font-dt" }
const _hoisted_18 = { class: "w-full mt-x1" }
const _hoisted_19 = {
  key: 0,
  class: "w-55"
}
const _hoisted_20 = ["src", "alt"]
const _hoisted_21 = { class: "flex-1" }
const _hoisted_22 = {
  key: 6,
  class: "font column"
}
const _hoisted_23 = { class: "font-dt" }

import { FabricCertificate, MaterialCover, FabricTest } from '@/types/productServerApi';
import TruncateText from '@/shared/navigation/TruncateText.vue';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import generateCdnUrlWithParams from '@/core/responsive/image/helpers/generate-cdn-url-including-params';
import PdfLinkDownload from '@/shared/navigation/pdf-link/PdfLinkDownload.vue';
import CO2EmissionsLogo from '@/shared/product/details/emissions/CO2EmissionsLogo.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchResultMaterialDetails',
  props: {
    cover: null,
    tests: null,
    certificates: null
  },
  setup(__props: any) {




const labels = useBlockLabels();

const getCertificationImageUrl = (imageUrl: string) => {
    return generateCdnUrlWithParams(
        imageUrl,
        { format: 'auto', width: 87, height: 54 },
        true);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(TruncateText, {
      "read-more-label": _unref(labels).overlayShowMaterialSpecifications,
      "read-less-label": _unref(labels).overlayHideMaterialSpecifications,
      "teaser-height": 0,
      "button-class": "mb-x3"
    }, {
      default: _withCtx(() => [
        _createElementVNode("p", {
          class: "font mb-x3",
          innerHTML: __props.cover.shortDescription
        }, null, 8, _hoisted_1),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("dl", null, [
              _createElementVNode("dt", _hoisted_4, _toDisplayString(_unref(labels).overlayMaterialSpecificationsMaterial), 1),
              _createElementVNode("dd", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.cover.compositions, (composition, idx) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: composition.material+idx
                  }, [
                    (idx > 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_5, "/"))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(composition.percentage) + "% " + _toDisplayString(composition.material), 1)
                  ], 64))
                }), 128))
              ])
            ])
          ]),
          (__props.cover.martinDale)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("dl", null, [
                  _createElementVNode("dt", _hoisted_7, _toDisplayString(_unref(labels).overlayMaterialSpecificationsMartindale), 1),
                  _createElementVNode("dd", null, _toDisplayString(__props.cover.martinDale), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (__props.cover.lightFastness)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("dl", null, [
                  _createElementVNode("dt", _hoisted_9, _toDisplayString(_unref(labels).overlayMaterialSpecificationsLightFastness), 1),
                  _createElementVNode("dd", null, _toDisplayString(__props.cover.lightFastness), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (__props.cover.pilling)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("dl", null, [
                  _createElementVNode("dt", _hoisted_11, _toDisplayString(_unref(labels).overlayMaterialSpecificationsPilling), 1),
                  _createElementVNode("dd", null, _toDisplayString(__props.cover.pilling), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (__props.cover.washingInstructions)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("dl", null, [
                  _createElementVNode("dt", _hoisted_13, _toDisplayString(_unref(labels).washingInstructions), 1),
                  _createElementVNode("dd", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.cover.washingInstructions, (item) => {
                      return (_openBlock(), _createElementBlock("div", { key: item }, _toDisplayString(item), 1))
                    }), 128))
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (__props.cover.fabricClimateEmission?.climateEmission)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("dl", null, [
                  _createElementVNode("dt", _hoisted_15, [
                    _createVNode(CO2EmissionsLogo, { class: "h-16 mr-x1" }),
                    _createTextVNode(_toDisplayString(_unref(labels).overlayMaterialSpecificationsClimateEmissions), 1)
                  ]),
                  _createElementVNode("dd", null, _toDisplayString(__props.cover.fabricClimateEmission.climateEmission.emissionValue) + " " + _toDisplayString(__props.cover.fabricClimateEmission.climateEmission.screeningSpecification), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (!!__props.certificates?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createElementVNode("dl", null, [
                  _createElementVNode("dt", _hoisted_17, _toDisplayString(_unref(labels).overlayMaterialCertificates), 1),
                  _createElementVNode("dd", null, [
                    _createElementVNode("ul", _hoisted_18, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.certificates, (cert) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: cert.name,
                          class: "font flex flex-row items-center gap-x3 mb-x2 last:mb-0"
                        }, [
                          (cert.imageUrl)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                _createElementVNode("img", {
                                  src: getCertificationImageUrl(cert.imageUrl),
                                  alt: cert.name
                                }, null, 8, _hoisted_20)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_21, _toDisplayString(cert.name), 1)
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (!!__props.tests?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _createElementVNode("dl", null, [
                  _createElementVNode("dt", _hoisted_23, _toDisplayString(_unref(labels).overlayMaterialTests), 1),
                  _createElementVNode("dd", null, [
                    _createElementVNode("ul", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tests, (test) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: test.name,
                          class: "font mb-x2 last:mb-0"
                        }, [
                          _createElementVNode("div", null, _toDisplayString(test.name), 1),
                          (test.documentUrl)
                            ? (_openBlock(), _createBlock(PdfLinkDownload, {
                                key: 0,
                                class: "mt-x1",
                                label: _unref(labels).overlayMaterialTestsDownload,
                                "is-direct-link": true,
                                url: test.documentUrl
                              }, null, 8, ["label", "url"]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["read-more-label", "read-less-label"])
  ]))
}
}

})